import React from 'react';
import { heroTestimonials } from '../../data/content';
import { Stars } from '../ui/Stars';
const socialProofStats = [{
  value: '500+',
  label: 'Clientes'
}, {
  value: '4.9/5',
  label: 'Calificación'
}, {
  value: '100%',
  label: 'Satisfacción'
}];
export function HeroTestimonials() {
  return <section aria-label="Testimonios destacados" className="w-full bg-ink-850" data-id="element-123" data-mp="2f5mp2s4l8t47">
      <div className="mx-auto max-w-5xl px-5 pt-16 md:pt-20" data-id="element-124" data-mp="1hhkvnstw6oih">
        <dl className="grid grid-cols-3 divide-x divide-ink-border rounded-2xl border border-ink-border bg-ink-card py-6" data-id="element-125" data-mp="1hj5p1f4h01er">
          {socialProofStats.map(stat => <div key={stat.label} className="flex flex-col items-center px-3 text-center" data-id="element-126" data-mp="1reh5q2zfvip5">
              <dt className="sr-only" data-id="element-127" data-mp="1wevdrl11isn6">{stat.label}</dt>
              <dd className="font-display text-3xl font-black leading-none text-white md:text-4xl" data-id="element-128" data-mp="1wc8z71fqfcvg">
                {stat.value}
              </dd>
              <p aria-hidden="true" className="mt-2 text-xs font-semibold uppercase tracking-[0.12em] text-subtle md:text-sm" data-id="element-129" data-mp="37spi54qhwbn2">
                {stat.label}
              </p>
            </div>)}
        </dl>
      </div>
      <div className="mx-auto grid max-w-5xl gap-6 px-5 py-10 md:grid-cols-2 md:pb-20" data-id="element-130" data-mp="2ygfgx7esr6o5">
        {heroTestimonials.map(item => <figure key={item.name} className="flex h-full flex-col rounded-2xl border border-ink-border bg-ink-card p-7 shadow-panel" data-id="element-131" data-mp="2pey2dth1fd1k">
            <Stars data-id="element-132" data-mp="2kh62oda5immt" />
            <blockquote className="mt-4 flex-1 text-base italic leading-relaxed text-body" data-id="element-133" data-mp="2khpmjzjd3l3h">
              “{item.quote}”
            </blockquote>
            <figcaption className="mt-6 border-t border-ink-border pt-4" data-id="element-134" data-mp="2ar38wav7h4nf">
              <span className="block text-sm font-bold text-white" data-id="element-135" data-mp="26ozx1l4mjy1m">{item.name}</span>
              <span className="block text-sm text-subtle" data-id="element-136" data-mp="21pdhh51bq5pn">{item.role}</span>
            </figcaption>
          </figure>)}
      </div>
    </section>;
}